// UI COMPONENTS
import { Button, Modal, Card, Row, Col } from "react-bootstrap";
// HOOKS & ICONS
import { useNavigate } from "react-router-dom";
import { BsArrowLeft } from "react-icons/bs";
// API handlers
import {
  GetRequest,
  PostRequest,
} from "../../../Utils/hooks/ApiHandler";
import useLocalStorageState from "use-local-storage-state";
import { useEffect, useState } from "react";
import { baseURL } from "../../../Utils/constants/constant";
import { toast } from "sonner";
export const Templates = () => {
  //  Getting 1 info from session storage
  const [customer, setCustomer] = useLocalStorageState("customer");

  //  Local states for managing template data, errors, and loading state
  const navigate = useNavigate();

  const token = customer?.token?.authorization;
  const rf = customer?.token?.authentication;
  const headers = {
    authentication: rf,
    Authorization: token,
  };

  const [selectedTemplateId, setSelectedTemplateId] = useState(null);
  const extras = { customer, setCustomer, rf, navigate };
  const [showTemplate, setTemplate] = useState(false);
  const [templateData, setTemplateData] = useState([]);
  const [selectedTemplate, setSelectedTemplate] = useState(null);
  const [selectedTemplateCode, setSelectedTemplateCode] = useState(null);
  const [loading, setLoading] = useState(true);
  const [previewLoading, setPreviewLoading] = useState(false);


  // master permissions 
  const permission = customer.customer_details?.permission;
  const user_type = Number(customer.customer_details?.user_type)
  const settingsPermission = permission?.filter(c => c.module_name === "setting")
  // view permission for master 
  const masterGrant = {
    isView: user_type !== 1 ? Boolean(Number(settingsPermission?.find(c => c.feature_name === "master")?.view)) : true,
    isCreate: user_type !== 1 ? Boolean(Number(settingsPermission?.find(c => c.feature_name === "master")?.create)) : true,
    isEdit: user_type !== 1 ? Boolean(Number(settingsPermission?.find(c => c.feature_name === "master")?.edit)) : true,
    isDelete: user_type !== 1 ? Boolean(Number(settingsPermission?.find(c => c.feature_name === "master")?.delete)) : true,
  }
  const fetchTemplates = async () => {
    try {
      setLoading(true);
      const res = await GetRequest(`masters/fetchTemplates/${customer.customer_details?.customer_id}`, { headers }, extras);
      setTemplateData(res.data || []);
    } catch (error) {
      console.error("Error fetching templates:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchTemplates();
  }, []);

  useEffect(() => {
    if (showTemplate && selectedTemplateCode) {
      // Small delay to ensure modal is fully rendered
      setTimeout(() => {
        const element = document.getElementById('codeUi');
        if (element) {
          element.innerHTML = selectedTemplateCode;
        }
      }, 100);
    }
  }, [showTemplate, selectedTemplateCode]);

  const handleTemplatePreview = async (template) => {
    try {
      setPreviewLoading(true);
      const res = await GetRequest(
        `masters/showTemplatePreview/${customer.customer_details?.customer_id}/${template.id}`,
        { headers },
        extras
      );

      if (res.status === 'fail' || res.success === false) {
        console.error("Failed to fetch template preview");
        return;
      }

      setSelectedTemplate(template);
      setSelectedTemplateCode(res.data);
      setTemplate(true);
    } catch (error) {
      console.error("Error fetching template preview:", error);
    } finally {
      setPreviewLoading(false);
    }
  };

  const handleSelectTemplate = async (template) => {
    try {
      const payload = {
        customer_id: customer.customer_details?.customer_id,
        template_id: template.id,
        user_login_id: customer.customer_details?.id
      }
      const res = await PostRequest('masters/SelectTemplate', payload, false, { headers }, extras)
      if (res.status === "fail" || res.success === false) {
        toast.error(res.message)
        return
      }
      fetchTemplates()

      // After successful selection, you might want to update the selected template state
      // setSelectedTemplateId(template.id); // Assuming you have this state
    } catch (error) {
      return
    }
  };

  // Template card UI function 
  const TemplateCard = ({ template, isSelected }) => (
    <Col xs={12} sm={6} md={4} lg={3} className="mb-4">
      <div style={{ position: 'relative', overflow: 'hidden' }}>
        <Card
          className="template-card h-100 shadow-sm border-0"
          style={{ cursor: 'pointer', transition: 'all 0.3s ease' }}
          onMouseEnter={(e) => {
            e.currentTarget.style.transform = 'translateY(-5px)';
            e.currentTarget.style.boxShadow = '0 8px 25px rgba(0,0,0,0.15)';
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.transform = 'translateY(0)';
            e.currentTarget.style.boxShadow = '0 2px 10px rgba(0,0,0,0.1)';
          }}
        >
          <div className="template-image-container" style={{
            height: '200px',
            overflow: 'hidden',
            borderRadius: '8px 8px 0 0',
            backgroundColor: '#f8f9fa'
          }}>
            {template.image ? (
              <Card.Img
                variant="top"
                src={`${baseURL}/${template.image}`}
                alt={template.name || 'Template'}
                style={{
                  height: '100%',
                  width: '100%',
                  objectFit: 'cover',
                  transition: 'transform 0.3s ease'
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = 'scale(1.05)';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = 'scale(1)';
                }}
              />
            ) : (
              <div
                className="d-flex align-items-center justify-content-center h-100 text-muted"
                style={{ fontSize: '3rem' }}
              >
                📄
              </div>
            )}
          </div>
          <Card.Body className="p-3">
            <Card.Title
              className="mb-2 text-truncate"
              style={{ fontSize: '0.95rem', fontWeight: '600', textTransform: 'capitalize' }}
            >
              {template.name || template.title || 'Untitled Template'}
            </Card.Title>
            <Card.Text
              className="text-muted small mb-0 text-truncate"
              style={{ fontSize: '0.8rem', textTransform: 'capitalize' }}
            >
              {template.description || template.category || 'Template'}
            </Card.Text>
          </Card.Body>
          <div className="template-overlay position-absolute w-100 h-100 d-flex align-items-center justify-content-center"
            style={{
              background: 'rgba(0,0,0,0.7)',
              opacity: 0,
              transition: 'opacity 0.3s ease',
              borderRadius: '8px',
              top: 0,
              left: 0
            }}
            onMouseEnter={(e) => e.currentTarget.style.opacity = 1}
            onMouseLeave={(e) => e.currentTarget.style.opacity = 0}
          >
            <div className="d-flex gap-2">
              <Button
                className="btn btn-default-outline"
                size="sm"
                disabled={previewLoading}
                onClick={(e) => {
                  e.stopPropagation();
                  handleTemplatePreview(template);
                }}
              >
                {previewLoading ? 'Loading...' : 'Preview'}
              </Button>
              <Button
                className="btn btn-default"
                size="sm"
                onClick={(e) => {
                  e.stopPropagation();
                  handleSelectTemplate(template);
                }}
              >
                Select
              </Button>
            </div>
          </div>
        </Card>

        {/* Selected Ribbon - Diagonal with tucked edges */}
        {isSelected && (
          <div className="ribbon-wrapper">
            <div className="ribbon">SELECTED</div>
            <style>
              {`
              .ribbon-wrapper {
                position: absolute;
                top: -5px;
                left: -5px;
                overflow: hidden;
                width: 90px;
                height: 90px;
                z-index: 10;
              }
              
              .ribbon {
                position: relative;
                display: block;
                text-align: center;
                font-size: 11px;
                font-weight: 700;
                letter-spacing: 0.5px;
                text-transform: uppercase;
                color: white;
                background: linear-gradient(135deg, #28a745 0%, #20c997 100%);
                box-shadow: 0 2px 8px rgba(40, 167, 69, 0.4);
                padding: 6px 0;
                left: -25px;
                top: 20px;
                width: 120px;
                transform: rotate(-45deg);
              }
              
            `}
            </style>
          </div>
        )}
      </div>
    </Col>
  );


  // Loading skeleton for templates
  const LoadingSkeleton = () => (
    <Col xs={12} sm={6} md={4} lg={3} className="mb-4">
      <Card className="h-100 border-0">
        <div
          className="bg-light"
          style={{ height: '200px', borderRadius: '8px 8px 0 0' }}
        >
          <div className="skeleton-loading h-100 w-100"></div>
        </div>
        <Card.Body className="p-3">
          <div className="skeleton-loading mb-2" style={{ height: '20px', width: '80%' }}></div>
          <div className="skeleton-loading" style={{ height: '16px', width: '60%' }}></div>
        </Card.Body>
      </Card>
    </Col>
  );

  return (
    <div className="container-fluid p-3 product-container mb-5">
      <style jsx>{`
        .template-card {
          position: relative;
          overflow: hidden;
        }

        .skeleton-loading {
          background: linear-gradient(
            90deg,
            #f0f0f0 25%,
            #e0e0e0 50%,
            #f0f0f0 75%
          );
          background-size: 200% 100%;
          animation: loading 1.5s infinite;
          border-radius: 4px;
        }

        @keyframes loading {
          0% {
            background-position: 200% 0;
          }
          100% {
            background-position: -200% 0;
          }
        }

        .template-grid {
          gap: 1rem;
        }
      `}</style>

      <div className="d-flex justify-content-between align-items-center flex-wrap mb-4">
        <div style={{ width: "80%", paddingRight: "20px" }}>
          <h5 className="fw-semibold mb-1">Templates</h5>
          <p className="text-muted small">
            Choose from our collection of professionally designed templates.
          </p>
        </div>
        <div className="d-flex align-items-center gap-2">
          <Button
            className="btn btn-default-outline"
            onClick={() => navigate(-1)}
          >
            <BsArrowLeft className="me-1" /> Back
          </Button>
          {/* <Dropdown>
            <Dropdown.Toggle className=" btn btn-default no-arrow" style={{ display: "flex", alignItems: "center", paddingRight: "7px" }}>
              Action
              <i class="bx bx-chevron-down" style={{ fontSize: "21px" }}></i>
            </Dropdown.Toggle>
            <Dropdown.Menu>
              <Dropdown.Item>Import</Dropdown.Item>
              <Dropdown.Item>Export</Dropdown.Item>
              <Dropdown.Item>Copy from Other</Dropdown.Item>
              <Dropdown.Item>SVC Data</Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>  */}
        </div>
      </div>
      <hr
        className="mb-4"
        style={{ borderTop: "0.5px solid #6c757d", opacity: "0.3", marginTop: "0.7rem" }}
      />

      {/* Templates Grid */}
      <Row className="template-grid">
        {
          masterGrant?.isView ?
            loading ? (
              // Loading skeletons
              Array.from({ length: 8 }).map((_, index) => (
                <LoadingSkeleton key={index} />
              ))
            ) : templateData.length > 0 ? (
              // Template cards
              templateData.map((template, index) => (
                <TemplateCard
                  key={template.id || index}
                  template={template}
                  isSelected={template?.selected === "selected" ? true : false}
                />
              ))
            ) : (
              // Empty state
              <Col xs={12} className="text-center py-5">
                <div className="text-muted">
                  <h4>No templates found</h4>
                  <p>Templates will appear here once they're available.</p>
                </div>
              </Col>
            )
            :
            <>You are not authorized to view Templates!</>
        }
      </Row>

      {/* Template Preview Modal */}
      <Modal show={showTemplate} size="lg" onHide={() => setTemplate(false)}>
        <Modal.Header closeButton>
          <Modal.Title>
            {selectedTemplate?.name ||
              selectedTemplate?.title ||
              "Template Preview"}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {previewLoading ? (
            <div className="text-center py-5">
              <div className="spinner-border" role="status">
                <span className="visually-hidden">Loading...</span>
              </div>
              <p className="mt-2">Loading template preview...</p>
            </div>
          ) : (
            <div id="codeUi"></div>
          )}
        </Modal.Body>
      </Modal>
    </div>
  )
};